/**
 * Prix d'un produit ou d'une variante dans une liste. La ligne de la variante
 * a priorité sur celle du produit ; une ligne inactive est ignorée. Retourne
 * null quand la liste n'a pas de prix pour ce produit.
 */
export function findPriceListPrice(priceList, itemId, variantId) {
    var _a;
    if (priceList == null || itemId == null) {
        return null;
    }
    const lines = ((_a = priceList.items) !== null && _a !== void 0 ? _a : []).filter((line) => line.active && line.item.id == itemId);
    if (variantId) {
        const variantLine = lines.find((line) => { var _a; return ((_a = line.variant) === null || _a === void 0 ? void 0 : _a.id) == variantId; });
        if (variantLine) {
            return variantLine.price;
        }
    }
    const itemLine = lines.find((line) => line.variant == null);
    return itemLine ? itemLine.price : null;
}
/**
 * Listes proposées dans une soumission : les listes globales, celle du
 * client de la soumission et celle de l'utilisateur. Les listes réservées à
 * un autre client ou utilisateur, et celles des ententes ou de Shopify, sont
 * écartées. La liste du client vient en premier.
 */
export function listsForDeal(priceLists, context) {
    const rank = (priceList) => {
        switch (priceList.entity) {
            case 'CLIENT':
                return context.clientId && priceList.entityId == context.clientId
                    ? 0
                    : null;
            case 'USER':
                return context.userId && priceList.entityId == context.userId
                    ? 1
                    : null;
            case 'GLOBAL':
                return 2;
        }
        return null;
    };
    return (priceLists !== null && priceLists !== void 0 ? priceLists : [])
        .filter((priceList) => priceList.active && rank(priceList) != null)
        .sort((a, b) => { var _a, _b; return ((_a = rank(a)) !== null && _a !== void 0 ? _a : 0) - ((_b = rank(b)) !== null && _b !== void 0 ? _b : 0); });
}
/**
 * Liste appliquée d'office à un produit ajouté à une soumission : la liste
 * du client, si elle a un prix pour ce produit ou cette variante.
 */
export function defaultDealPriceList(priceLists, context, itemId, variantId) {
    var _a;
    return ((_a = listsForDeal(priceLists, context).find((priceList) => priceList.entity == 'CLIENT' &&
        findPriceListPrice(priceList, itemId, variantId) != null)) !== null && _a !== void 0 ? _a : null);
}
